import React from 'react';
import * as Styles from './Header.styles';
import {
  Button, IconAdd, TextField,
} from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';

const Header = ({
  searchInput,
  handleSearch,
  onNewServer,
  emptyPage,
}) => {
  const { productDetails: productDetailsLocale } = useLocale();
  const { advancedHosting: advancedHostingLocale } = productDetailsLocale || {};
  const { header: headerLocale } = advancedHostingLocale || {};

  const onSearchChange = (e) => {
    handleSearch(e.target.value);
  };

  return (
    <Styles.Header data-testid="advanced-hosting-header">
      <Styles.Title data-testid="advanced-hosting-header-title">{headerLocale?.title}</Styles.Title>

      {!emptyPage && (
        <Styles.Actions>
          <Styles.TextFieldWrapper>
            <TextField
              placeholder={headerLocale?.searchInput?.placeholder}
              label={headerLocale?.searchInput?.placeholder}
              type="search"
              value={searchInput}
              onChange={onSearchChange}
              onClear={() => handleSearch('')}
              inputHeight={46}
              testId="advanced-hosting-search-input"
            />
          </Styles.TextFieldWrapper>
          <Button
            label={headerLocale?.buttons?.newServer}
            variant="primary"
            size="large"
            version="v2"
            width="full"
            iconLeft={<IconAdd color="highPure" />}
            notFillSVG
            onClick={onNewServer}
            testId="advanced-hosting-new-server-button"
          />
        </Styles.Actions>
      )}
    </Styles.Header>
  );
};

export default Header;
